import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
import { footerLinks } from '../../data/mock';

export const Footer = () => {
  return (
    <footer className="relative bg-[var(--bg-soft)] border-t border-[var(--border-color)] transition-colors duration-300">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-5 group">
              <img
                src="/f.png"
                alt="Your IT Solution"
                className="h-14 w-auto object-contain opacity-90 transition-all duration-300 group-hover:opacity-100 group-hover:scale-105"
              />
              <span className="text-lg font-bold font-['Syne'] tracking-tight text-[var(--text-primary)]">
                Your <span className="text-blue-400">IT Solution</span>
              </span>
            </Link>

            <p className="text-[var(--text-muted)] text-sm leading-relaxed max-w-xs">
              We craft digital experiences that drive growth. From stunning websites to data-driven marketing, we help brands thrive online.
            </p>
          </div>

          <div>
            <h4 className="text-[var(--text-primary)] font-semibold mb-5 text-sm uppercase tracking-wider">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-[var(--text-muted)] hover:text-blue-400 text-sm transition-colors duration-300 flex items-center gap-1 group"
                  >
                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-0.5 translate-x-0 group-hover:opacity-100 transition-all duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[var(--text-primary)] font-semibold mb-5 text-sm uppercase tracking-wider">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-[var(--text-muted)] hover:text-blue-400 text-sm transition-colors duration-300 flex items-center gap-1 group"
                  >
                    {link.name}
                    <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-0.5 translate-x-0 group-hover:opacity-100 transition-all duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[var(--text-primary)] font-semibold mb-5 text-sm uppercase tracking-wider">Get In Touch</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`mailto:${footerLinks.contact.email}`}
                  className="text-[var(--text-muted)] hover:text-blue-400 text-sm transition-colors duration-300 flex items-center gap-2"
                >
                  <Mail className="w-4 h-4 text-blue-500/70" />
                  {footerLinks.contact.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${footerLinks.contact.phone}`}
                  className="text-[var(--text-muted)] hover:text-blue-400 text-sm transition-colors duration-300 flex items-center gap-2"
                >
                  <Phone className="w-4 h-4 text-blue-500/70" />
                  {footerLinks.contact.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-blue-500/70 mt-0.5 shrink-0" />
                <span className="text-[var(--text-muted)] text-sm">{footerLinks.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[var(--border-color)] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[var(--text-muted)] text-sm">
            &copy; {new Date().getFullYear()} Your IT Solution. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            {Object.entries(footerLinks.social).map(([platform, url]) => (
              <a
                key={platform}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[var(--text-muted)] hover:text-blue-400 text-sm capitalize transition-colors duration-300"
              >
                {platform}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};